import {
  changeValueOfKeys,
  parseDimensions,
  parseMatchVariation,
  parseVariation,
} from 'core/common/utils/formikHelpers'

class FormikModel {
  initialValues = {
    selectedAttributes: {
      id1: {
        description: '',
        value: [],
      },
      id2: {
        description: '',
        value: [],
      },
    },
    variations: [],
    linkedProducts: [],
    unlinkedProducts: [],
    productRemovedVariation: false,
    channels: [],
    matchVariations: [],
    isPriceVariable: true,
    uploadedImages: [],
    genre: 'outros',
    brand: '',
    video: '',
    isVariationEnabled: false,
    datasheet: [
      {
        type: '',
        value: '',
      },
      {
        type: '',
        value: '',
      },
      {
        type: '',
        value: '',
      },
    ],
    name: '',
    ean: '',
    ncm: '',
    sku: '',
    isbn: '',
    description: '',
    origin: 'national',
    delivered: true,
    perishable: false,
    fulfillment: false,
    package: {
      standard_packing: false,
      height: 0,
      depth: 0,
      size: '',
      unit: 'm',
      weight: { value: 0, unit: 'kg' },
      width: 0,
    },
    tax_replacement: false,
    has_ean: undefined,
  }

  constructor(formik) {
    this.selectedAttributes = formik.selectedAttributes
    this.variations = formik.variations
    this.linkedProducts = formik.linkedProducts
    this.unlinkedProducts = formik.unlinkedProducts
    this.productRemovedVariation = formik.productRemovedVariation
    this.channels = formik.channels
    this.prices = formik.prices
    this.promotion_count = formik.promotion_count
    this.promotional_prices = formik.promotional_prices
    this.stocks = formik.stocks
    this.isPriceVariable = formik.isPriceVariable
    this.uploadedImages = formik.uploadedImages
    this.genre = formik.genre
    this.brand = formik.brand
    this.gender = formik.gender
    this.video = formik.video
    this.isVariationEnabled = formik.isVariationEnabled
    this.datasheet = formik.datasheet
    this.name = formik.name
    this.ean = formik.ean
    this.ncm = formik.ncm
    this.tax_replacement = formik.tax_replacement
    this.sku = formik.sku
    this.type = formik.type
    this.isbn = formik.isbn
    this.description = formik.description
    this.origin = formik.origin
    this.delivered = formik.delivered
    this.perishable = formik.perishable
    this.fulfillment = formik.fulfillment
    this.package = formik.package
    this.matchVariations = formik.matchVariations
    this.anatel = formik.anatel
    this.isAnatelEnabled = formik.isAnatelEnabled
    this.has_ean = !formik.not_has_ean
    this.update_only_front = formik.update_only_front

    Object.entries(this.initialValues).forEach(([key, value]) => {
      if (this[key] === null || this[key] === undefined) {
        this[key] = value
      }
    })
  }

  toProduct = () => {
    return {
      group_id: null,
      match_id: null,
      active: true,
      ean: this.ean,
      sku: this.sku,
      type: this.type,
      isbn: this.isbn,
      origin: this.origin,
      name: this.name,
      description: this.description,
      perishable: this.perishable,
      fulfillment: this.fulfillment,
      brand: this.brand,
      gender: this.gender,
      ncm: this.ncm.replace(/\./g, ''),
      tax_replacement: this.tax_replacement,
      package: parseDimensions(this?.package),
      dimension: parseDimensions(this?.package),
      channels: this.channels,
      videos: this.video ? [this.video] : [],
      images: this.uploadedImages?.filter(image => image.url).map(image => image.url),
      stocks: this.stocks,
      prices: this.prices,
      datasheet: this.datasheet,
      has_ean: this.has_ean,
      update_only_front: this.update_only_front,
    }
  }

  toNewProductsArray(variationId, match_id) {
    const product = {
      ...this.toProduct(),
      match_id,
    }

    if (this.variations.length === 0) {
      return [changeValueOfKeys(product, ['isbn', 'ncm', 'ean'])]
    }

    // TODO: verificar consistência dos dados ao remover o && variation.active
    return this.variations
      .filter(variation => !!variation.sku)
      .filter(variation => !variation.linked)
      .map(variation => {
        const ean = variation.ean || product.ean
        if (variation.id === variationId) {
          const variationImagesToUpdate = product.images

          return changeValueOfKeys(
            {
              ...product,
              ...parseVariation(variation),
              ean,
              images: variationImagesToUpdate,
            },
            ['isbn', 'ncm', 'ean']
          )
        }

        return changeValueOfKeys({ ...product, ...parseVariation(variation), ean }, [
          'isbn',
          'ncm',
          'ean',
        ])
      })
  }

  toMatchProductsArray = match_id => {
    const product = {
      ...this.toProduct(),
      match_id,
    }
    const isMatchVariationSelected = this.matchVariations.some(
      selectedVariation => selectedVariation.selected
    )

    if (!this.variations.length && !isMatchVariationSelected) {
      return [changeValueOfKeys(product, ['isbn', 'ncm', 'ean'])]
    }
    return [
      ...this.variations
        .filter(variation => !variation.linked && variation.active)
        .map(variation =>
          changeValueOfKeys({ ...product, ...parseVariation(variation) }, ['isbn', 'ncm', 'ean'])
        ),
      ...this.matchVariations
        .filter(matchVariation => matchVariation.selected)
        .map(matchVariation =>
          changeValueOfKeys({ ...product, ...parseMatchVariation(this, matchVariation) }, [
            'isbn',
            'ncm',
            'ean',
          ])
        ),
    ]
  }

  toLinkedProductsArray(groupId) {
    return this.linkedProducts.map(linkedProduct => {
      const variation = this.variations.find(
        findableVariation => findableVariation.sku === linkedProduct.sku
      )
      const parsedVariation = parseVariation(variation)

      return {
        prices: parsedVariation.prices,
        stocks: parsedVariation.stocks,
        id: linkedProduct.id,
        group_id: groupId,
        active: linkedProduct.active,
        sku: linkedProduct.sku,
      }
    })
  }
}

export default FormikModel
